import Openrouteservice from 'openrouteservice-js'
import { IOSMDirectionReq } from 'src/types'

class OSMService {
  public openRouteDirectionService: any

  constructor() {
    this.openRouteDirectionService = new Openrouteservice.Directions({ api_key: process.env.REACT_APP_OSM_KEY })
  }

  public async getDirection(req: IOSMDirectionReq) {
    try {
      const result = await this.openRouteDirectionService.calculate({
        coordinates: req.location,
        profile: 'driving-car'
      })
      console.log('OSM result: ', result)
      return result
    } catch (err) {
      console.log('OSM err: ', err)
    }
  }
}

const osmService = new OSMService()
export { osmService }



// WEBPACK FOOTER //
// ./src/services/OSMService.ts